import React, { useState } from 'react'
import InfiniteScroll from 'react-infinite-scroller'
import { Hit } from 'react-instantsearch-core'
import { connectInfiniteHits } from 'react-instantsearch-dom'

import NoSSR from 'components/NoSSR'
import { AlgoliaProfileHitProps } from 'components/SearchResults/AlgoliaProfileHitProps'
import MoreButton from 'components/SearchResults/MoreButton'
import SearchResultList from 'components/SearchResults/SearchResultList'

const InfiniteSearchResultList = ({
  hits,
  refineNext,
  hasMore,
  potentialProfiles,
}: {
  hits: Hit<AlgoliaProfileHitProps>[]
  refineNext: () => void
  hasMore: boolean
  potentialProfiles?: boolean
}) => {
  const [infiniteScrollEnabled, setInfiniteScrollEnabled] = useState(false)

  if (!hits || !hits.length) {
    return null
  }

  const loading = false // TODO get this from where?

  return (
    <NoSSR>
      <InfiniteScroll
        loadMore={refineNext}
        hasMore={!loading && hasMore && infiniteScrollEnabled}
        initialLoad={false}
      >
        <SearchResultList hits={hits} potentialProfiles={potentialProfiles} />
      </InfiniteScroll>
      {hasMore && !!refineNext && !infiniteScrollEnabled && (
        <MoreButton
          setShowInfiniteScroll={setInfiniteScrollEnabled}
          loadMore={refineNext}
          loading={loading}
        />
      )}
    </NoSSR>
  )
}

export default connectInfiniteHits(InfiniteSearchResultList)
